export default __webpack_public_path__ + "static/media/bg1.be7c011c.jpg";